module.exports = __webpack_public_path__ + "static/gilroy-regular-93a118ae3780dd9c4acc80c606b3c1b5.otf";